import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { ExecutionStatus } from '../transportAssignment.types';
import Button from '@rio-cloud/rio-uikit/Button';

export type ExecutionStatusActionButtonProps = {
    readonly status: ExecutionStatus;
    readonly isTransportAssignmentConfirmed: boolean;
    readonly hasLoadedStatus: boolean;
    readonly hasUnloadedStatus: boolean;
    readonly onClick: () => void;
    readonly disabled: boolean;
    readonly isLoading?: boolean;
};

const getActionButtonProperties = (
    status: ExecutionStatus,
    hasLoadedStatus: boolean,
    hasUnloadedStatus: boolean,
): { iconClassName: string; labelMessageId: string } => {
    const hasStatus =
        (status === ExecutionStatus.LOADED && hasLoadedStatus) ||
        (status === ExecutionStatus.UNLOADED && hasUnloadedStatus);

    if (hasStatus) {
        return {
            iconClassName: 'rioglyph rioglyph-time',
            labelMessageId: 'outboundPortal.transportAssignments.sidebar.executionStatus.updateStatus',
        };
    }

    switch (status) {
        case ExecutionStatus.LOADED:
            return {
                iconClassName: 'rioglyph rioglyph-parcel',
                labelMessageId: 'outboundPortal.transportAssignments.sidebar.executionStatus.confirmLoading',
            };
        case ExecutionStatus.UNLOADED:
            return {
                iconClassName: 'rioglyph rioglyph-finish',
                labelMessageId: 'outboundPortal.transportAssignments.sidebar.executionStatus.confirmUnloading',
            };
    }
};

export const ExecutionStatusActionButton = ({
    status,
    isTransportAssignmentConfirmed,
    hasLoadedStatus,
    hasUnloadedStatus,
    onClick,
    disabled,
    isLoading = false,
}: ExecutionStatusActionButtonProps) => {
    const isPrimaryButton =
        (status === ExecutionStatus.LOADED &&
            isTransportAssignmentConfirmed &&
            !hasLoadedStatus &&
            !hasUnloadedStatus) ||
        (status === ExecutionStatus.UNLOADED && hasLoadedStatus && !hasUnloadedStatus);
    const { iconClassName, labelMessageId } = getActionButtonProperties(status, hasLoadedStatus, hasUnloadedStatus);

    return (
        <Button
            className={classNames('btn', 'btn-default', { 'btn-primary': isPrimaryButton, 'btn-loading': isLoading })}
            onClick={onClick}
            disabled={disabled}
        >
            <span className={classNames(iconClassName)} aria-hidden="true" />
            <FormattedMessage id={labelMessageId} />
        </Button>
    );
};
